import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PreviewServiceRequest {
  id: string;
  original_request: string;
  town: string;
  urgency: string;
  user_firstname: string;
  user_lastname: string;
  created_at: string;
  user_id: string;
  status: string;
}

export function usePreviewServiceRequests(communityId?: string, enabled: boolean = true) {
  return useQuery({
    queryKey: ['preview-service-requests', communityId],
    enabled: enabled && !!communityId,
    queryFn: async () => {
      if (!communityId) return [];

      const { data, error } = await supabase
        .from('service_requests')
        .select(`
          id,
          original_request,
          town,
          urgency,
          created_at,
          user_id,
          status,
          user_profiles!service_requests_user_id_fkey (
            firstname,
            lastname
          )
        `)
        .eq('community_id', communityId)
        .neq('status', 'completed')
        .order('created_at', { ascending: false })
        .limit(20);

      if (error) {
        console.error('Error fetching service requests:', error);
        throw error;
      }

      return (data || []).map((request: any) => ({
        id: request.id,
        original_request: request.original_request,
        town: request.town || '',
        urgency: request.urgency || 'normal',
        user_firstname: request.user_profiles?.firstname || '',
        user_lastname: request.user_profiles?.lastname || '',
        created_at: request.created_at,
        user_id: request.user_id,
        status: request.status
      })) as PreviewServiceRequest[];
    },
  });
}